module.exports = __webpack_public_path__ + "static/img/video.6d37bae6.png";